import uuid from "react-uuid";
import {
  MdDashboard,
  MdBusiness,
  MdHistory,
  MdHandshake,
  MdAccountBalanceWallet,
  MdStorefront,
} from "react-icons/md";

export const menuItems = [
  {
    id: uuid(),
    multiple: false,
    name: "Dashboard",
    menuLink: "/kohere/Dashboard",
    active: "Dashboard",
    icon: MdDashboard,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Company Details",
    menuLink: "/kohere/Companydetails",
    active: "Company Details",
    icon: MdBusiness,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My History",
    menuLink: "/kohere/myhistory",
    active: "My History",
    icon: MdHistory,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My Kohere",
    menuLink: "/kohere/mykohere",
    active: "My Koheres",
    icon: MdHandshake,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My Credits",
    menuLink: "/kohere/mycredits",
    active: "My Credits",
    icon: MdAccountBalanceWallet,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My Business For Sale",
    menuLink: "/kohere/mybusinessforsale",
    active: "My Business For Sale",
    icon: MdStorefront,
  },
];
